import { render, staticRenderFns } from "./EducationalGroupFilter.vue?vue&type=template&id=080afc80&"
import script from "./EducationalGroupFilter.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports